module.exports = __webpack_public_path__ + "media/images/ln/horoscope_6-9b4c178930a93ef960dda0875bc5870d.png";